// @ts-check

import BodyChart from "~/components/Shared/BodyChart";

export default function BodyChartField({ selectedBodyParts = [], onChange, disabled = false }) {
    return <BodyChart selectedBodyParts={selectedBodyParts} onChange={onChange} disabled={disabled} />;
}
